// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b9bd5730","453":"e9d19f84","455":"ddcb9d23","977":"793c3e5b"}[chunkId] + ".chunk.js";
};